import { FC } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Link,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react';

import webView from 'common/webView';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';

import StepLayout from '../../../../layout/Step';
import { locales } from './locales';

interface AdditionalInfoProps {
  isOpen: boolean;
  onClose: () => void;
}

const AdditionalInfo: FC<AdditionalInfoProps> = ({ isOpen, onClose }) => {
  const { isInWebView } = webView;

  const content = (
    <>
      <UnorderedList>
        <ListItem>{locales.one}</ListItem>
        <br />
        <ListItem>
          {locales.two}
          <br />
          <Link
            fontWeight="normal"
            href={locales.url}
            size="sm"
            target="_blank"
          >
            {locales.more}
          </Link>
        </ListItem>
      </UnorderedList>
      <br />
      {locales.conclude}
    </>
  );

  if (isInWebView) {
    return (
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent margin={0}>
          <DrawerBody>
            <Heading marginBottom="space-24" textAlign="center">
              {locales.title}
            </Heading>

            {content}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <StepLayout.Sidebar overflowY="visible">
      <Callout variant="info">
        <Callout.Title>{locales.title}</Callout.Title>

        <Callout.Content>{content}</Callout.Content>
      </Callout>
    </StepLayout.Sidebar>
  );
};

export default AdditionalInfo;
